import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import type { ChartLineSeries, ChartDataPoint } from "../../types/reports.types";

interface AreaChartCardProps {
  data?: ChartDataPoint[];
  areas?: ChartLineSeries[];
  loading?: boolean;
}

export default function AreaChartCard({
  data = [],
  areas = [],
  loading = false,
}: AreaChartCardProps) {
  if (loading) {
    return <div className="chartState">Loading chart...</div>;
  }

  if (!data.length || !areas.length) {
    return <div className="chartState empty">No area data available</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e6edf4" />
        <XAxis dataKey="name" tick={{ fontSize: 10 }} />
        <YAxis tick={{ fontSize: 10 }} />
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 10 }} />
        {areas.map((series) => (
          <Area
            key={series.dataKey}
            type="monotone"
            dataKey={series.dataKey}
            name={series.name}
            stroke={series.color}
            fill={series.fill ?? series.color}
            fillOpacity={0.15}
            strokeWidth={2}
            isAnimationActive
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
}
